import React from 'react'

import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'language/translator'

import { sortAlphabeticalAsc } from 'utils/sortHelper'

import ChipTabs from 'components_new/molecules/ChipTabs'
import SectionHeader from 'components_new/molecules/SectionHeader'

import PageLayout, {
  PageLayoutProps
} from 'components_new/templates/PageLayout'
import { useSettingItems } from 'components_new/pages/SettingsLanding/lib'

interface Props extends Omit<PageLayoutProps, 'variant'> {
  disableNav?: boolean
}

const SettingsTemplate = (props: Props) => {
  const { children, disableNav, topbar, ...rest } = props

  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const settingItems = useSettingItems()

  const setting = settingItems.find(
    (settingItem) => settingItem.href === location.pathname
  )

  return (
    <PageLayout
      content={{ size: 'large' }}
      topbar={{
        breadcrumbs: [
          { href: '/settings', title: t('global', 'settings') },
          {
            title: setting?.name ?? ''
          }
        ],
        ...topbar
      }}
      variant={'feed'}
      {...rest}
    >
      {disableNav ? null : (
        <ChipTabs
          disableAll={true}
          onChange={(value) => history.push(value as string)}
          options={settingItems
            .sort((a, b) => sortAlphabeticalAsc(a.name, b.name))
            .map((settingItem) => {
              return {
                disabled: settingItem.disabled,
                disabledTitle: settingItem.disabledTitle,
                icon: settingItem.icon,
                label: settingItem.name,
                value: settingItem.href as string
              }
            })}
          sx={{ mb: 6 }}
          value={location.pathname}
        />
      )}
      <SectionHeader
        body={setting?.body}
        size="large"
        sx={{ mb: 2 }}
        title={setting?.title}
      />
      {children}
    </PageLayout>
  )
}

export default SettingsTemplate
